import { OptionT } from '@hypercharge/hyperleasing-commons/lib/types/common';
import { Select } from 'antd';
import { FieldProps } from 'formik';
import { get } from 'lodash';
import React, { useMemo } from 'react';
import { ScError, ScFormItem, ScInputLabel } from './utils';

type Props = {
  className?: string;
  label?: string;
  options: OptionT[];
} & FieldProps<any>;

const FormSelect = ({ form: { errors }, field, label, options, className, ...props }: Props) => {
  const isError = useMemo(() => get(errors, field.name) != null, [errors, field]);
  const errorMessage = useMemo(
    () => (isError ? <ScError>{get(errors, field.name)}</ScError> : null),
    [isError, errors, field.name]
  );
  return (
    <>
      {label != null && <ScInputLabel>{label}</ScInputLabel>}
      <ScFormItem
        hasFeedback={isError}
        help={errorMessage}
        validateStatus={isError ? 'error' : undefined}
        className={className}
        {...field}
      >
        <Select onChange={(value: string) => field.onChange(field.name)(value)} {...props}>
          {options.map(({ value, label, disabled }) => (
            <Select.Option key={value} value={value} disabled={disabled}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </ScFormItem>
    </>
  );
};

export default FormSelect;
